export const quoteToScheduled = (orderId: string, status: string) => {
	return {
		method: "POST",
		url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/status/${status}`,
	}
}
